import React from 'react';
import loadable from '@loadable/component';
import { Switch, Route, Redirect } from 'react-router-dom';
import Score from './score';
import ScoreDetail from './score/detail';
import SportMatch from './match';
import ContactMarketingForm from './contact-pr-form';

const Routes = ({ handleRoute, path }) => {
  return (
    <Switch>
      <Route exact path='/contact-us' component={ContactMarketingForm} />
      <Route exact path='/:type' component={Score} />
      <Route exact path='/proto/win' component={Score} />
      <Route exact path='/:type/:id' component={ScoreDetail} />
      <Route
        eaxct
        path='/match/:sportsType(soccer|baseball|basketball|volleyball|hockey|football|lol|starcraft)/:id/:type'
        component={SportMatch}
      />
      <Redirect exact path='/match/lol/:id' to='/match/lol/:id/broadcast' />
      <Redirect exact path='/match/:sportsType/:id' to='/match/:sportsType/:id/stat' />
      <Route exact path='/match-tracker' component={null} />
    </Switch>
  );
};

export default Routes;
